import React, { useContext, useState, useEffect, useMemo } from 'react';
import { Button, Modal, Checkbox, List } from 'antd';
import { SocketContext } from '../../context/socketContext';
import { useDispatch, useSelector } from "react-redux";
import { onLeaveServed } from '../../redux/VisitorsJoined/VisitorsJoinedActions';

const TransferModal = ({ SelectedVisitorData, transferModalOpen, setTransferModalOpen }) => {
    const { Socket, FiltredUers, setTranserStatus, TranserStatus } = useContext(SocketContext);
    const userData = useSelector((state) => state.Auth.userData);
    const servedData = useSelector((state) => state.VisitorReducer.data);
    const dispatch = useDispatch();
    const [SelectedRow, setSelectedRow] = useState(null);
    const [statusCurrennt, setstatusCurrennt] = useState(null);

    const onlineAgents = useMemo(
        () =>
            (FiltredUers || []).filter(
                (item) =>
                    item?.status == 22 &&
                    String(item?._id) !== String(userData?._id)
            ),
        [FiltredUers, userData?._id]
    );

    const handleOk = () => {
        if (SelectedRow !== null && Socket) {
            Socket.emit("transferToAgent", {
                visitorData: SelectedVisitorData,
                agentData: SelectedRow,
                senderData: {
                    name: userData?.sudoName,
                    id: userData?._id,
                }
            }, (data) => {
                setstatusCurrennt(data);
            });
        }
    };

    useEffect(() => {
        if (!Socket) return undefined;
        const onAcceptStatus = (data) => {
            setstatusCurrennt(data);
            if (data?.status === "Accepted") {
                if (data?.visitorData?.unique_id == SelectedVisitorData?.unique_id) {
                    Socket.emit("agentLeaveRoomAfterTransfer", data);
                    setTransferModalOpen(false);
                    setSelectedRow(null);
                }
                setTimeout(() => {
                    dispatch(onLeaveServed(data?.visitorData, servedData));
                }, 300);
            }
        };
        Socket.on("acceptStatus", onAcceptStatus);
        return () => {
            Socket.off("acceptStatus", onAcceptStatus);
        };
    }, [Socket, SelectedVisitorData?.unique_id, setTransferModalOpen, dispatch, servedData]);

    useEffect(() => {
        if (statusCurrennt === null) return;
        if (TranserStatus?.length > 0) {
            let isInArrr = TranserStatus?.some((i) => i?.senderID == userData?._id && i?.visitorData?.unique_id == SelectedVisitorData?.unique_id);
            if (isInArrr) {
                let NewisInArrr = TranserStatus?.findIndex((i) => i?.senderID == userData?._id && i?.visitorData?.unique_id == SelectedVisitorData?.unique_id);
                const updatedData = [...TranserStatus]
                updatedData.splice(NewisInArrr, 1);
                updatedData.splice(NewisInArrr, 0, statusCurrennt);
                setTranserStatus(updatedData);
            }
            else {
                setTranserStatus((pre) => [statusCurrennt, ...pre]);
            }
        }
        else {
            setTranserStatus([statusCurrennt]);
        }
    }, [statusCurrennt]);

    const handleCancel = () => {
        setTransferModalOpen(false);
        setSelectedRow(null);
    };

    const onRowClick = (item) => {
        if (SelectedRow && String(SelectedRow?._id) === String(item?._id)) {
            setSelectedRow(null);
        } else {
            setSelectedRow(item);
        }
    };

    let findStatus = TranserStatus?.find((i) => i?.visitorData?.unique_id == SelectedVisitorData?.unique_id);
    return (
        <>
            <Modal title="Select Agent To Transfer" open={transferModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancle
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk} disabled={!SelectedRow}>
                    Send
                </Button>
            ]}>
                <List
                    itemLayout="horizontal"
                    dataSource={onlineAgents}
                    locale={{ emptyText: "No online agents available" }}
                    renderItem={(item, index) => (
                        <List.Item key={item?._id || index} style={{ padding: '4px 0px', cursor: 'pointer' }} onClick={() => onRowClick(item)}>
                            <div style={{ marginRight: 10 }}>
                                <Checkbox checked={String(SelectedRow?._id) === String(item?._id)} />
                            </div>
                            <List.Item.Meta
                                title={<p>{`${item?.name}-(${item?.sudoName})`}</p>}
                            />
                            {findStatus !== undefined && String(findStatus?.revicer) === String(item?._id) && <p> {findStatus?.status}</p>}
                        </List.Item>
                    )}
                />
            </Modal>
        </>
    );
}

export default TransferModal;
